module.exports = __webpack_public_path__ + "static/media/LOGO_1.e515113e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO_1.png
// module id = 260
// module chunks = 2